module.exports = __webpack_public_path__ + "img/kj.c99b3545.png";